<template>
    <div class="icon">
        <b-img :src="icon"  alt="..." fluid/>
    </div>
</template>

<script>
    export default {
        props: {
            icon: String
        }
    }
</script>

<style scoped lang="scss">
    .icon{
        width: 42px;
        height: 42px;
        min-width: 42px;
    }
</style>
